export const createQARequests = (client) => ({
    getActions: async () => {
        const { data } = await client.axios.get("/qa/actions");
        return data;
    },
    generateMissingScoresheetsForFlight: async (payload) => {
        const { data } = await client.axios.post("/qa/actions/generate-missing-scoresheets-for-flight", {
            contests_edition_id: payload.contestsEditionId,
            flight_id: payload.flightId,
            score_strategy: payload.scoreStrategy,
        });
        return {
            action: data.action,
            createdCount: data.created_count,
            skippedCount: data.skipped_count,
            createdScoresheetIds: data.created_scoresheet_ids,
            skipped: (data.skipped || []).map((s) => ({
                judgeId: s.judge_id,
                reason: s.reason,
            })),
        };
    },
    generateMissingScoresheetsForTable: async (payload) => {
        const { data } = await client.axios.post("/qa/actions/generate-missing-scoresheets-for-table", {
            contests_edition_id: payload.contestsEditionId,
            table_id: payload.tableId,
            score_strategy: payload.scoreStrategy,
        });
        return {
            action: data.action,
            createdCount: data.created_count,
            skippedCount: data.skipped_count,
            createdScoresheetIds: data.created_scoresheet_ids,
            skipped: (data.skipped || []).map((s) => ({
                judgeId: s.judge_id,
                reason: s.reason,
            })),
        };
    },
    generateEntries: async (payload) => {
        const { data } = await client.axios.post("/qa/actions/generate-entries", {
            contests_edition_id: payload.contestsEditionId,
            count: payload.count,
        });
        return {
            action: data.action,
            success: data.success,
            createdCount: data.created_count,
        };
    },
    payEntries: async (payload) => {
        const { data } = await client.axios.post("/qa/actions/pay-entries", {
            contests_edition_id: payload.contestsEditionId,
        });
        return {
            action: data.action,
            success: data.success,
            updatedCount: data.updated_count,
        };
    },
    checkInEntries: async (payload) => {
        const { data } = await client.axios.post("/qa/actions/check-in-entries", {
            contests_edition_id: payload.contestsEditionId,
        });
        return {
            action: data.action,
            success: data.success,
            updatedCount: data.updated_count,
        };
    },
    recodeEntries: async (payload) => {
        const { data } = await client.axios.post("/qa/actions/recode-entries", {
            contests_edition_id: payload.contestsEditionId,
            contests_edition_stage_id: payload.contestsEditionStageId,
        });
        return {
            action: data.action,
            success: data.success,
            updatedCount: data.updated_count,
        };
    },
    createFlights: async (payload) => {
        const { data } = await client.axios.post("/qa/actions/create-flights", {
            contests_edition_id: payload.contestsEditionId,
            contests_edition_stage_id: payload.contestsEditionStageId,
        });
        return {
            action: data.action,
            success: data.success,
            createdFlightsCount: data.created_flights_count,
            assignedEntriesCount: data.assigned_entries_count,
            skipped: data.skipped,
            reason: data.reason,
        };
    },
    assignTables: async (payload) => {
        const { data } = await client.axios.post("/qa/actions/assign-tables", {
            contests_edition_id: payload.contestsEditionId,
            contests_edition_stage_id: payload.contestsEditionStageId,
        });
        return {
            action: data.action,
            success: data.success,
            assignedCount: data.assigned_count,
        };
    },
});
//# sourceMappingURL=index.js.map